import { useState, useRef, useEffect } from 'react'
import { C, font } from '../design'

// Click-to-toggle popover — hover tooltips don't work well on mobile, and
// socionics abbreviations need room for a real explanation, not a native title.
export default function InfoTooltip({ label, title, children, labelStyle, align = 'left' }) {
  const [open, setOpen] = useState(false)
  const ref = useRef(null)

  useEffect(() => {
    if (!open) return
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false) }
    document.addEventListener('mousedown', onClick)
    return () => document.removeEventListener('mousedown', onClick)
  }, [open])

  return (
    <span ref={ref} style={{ position: 'relative', display: 'inline-block' }}>
      <span
        onClick={(e) => { e.stopPropagation(); setOpen(o => !o) }}
        style={{ cursor: 'help', borderBottom: '1px dotted currentColor', ...labelStyle }}
      >
        {label}
      </span>
      {open && (
        <div style={{
          position: 'absolute', bottom: '100%', [align]: 0, marginBottom: 6,
          background: '#0a0a16', border: `1px solid ${C.borderHi}`, borderRadius: 8,
          padding: '10px 12px', width: 250, zIndex: 50,
          boxShadow: '0 8px 24px rgba(0,0,0,0.45)',
        }}>
          {title && <div style={{ fontFamily: font.mono, fontSize: 10, color: C.accent, marginBottom: 4, letterSpacing: '0.03em' }}>{title}</div>}
          <div style={{ fontFamily: font.body, fontSize: 12, color: C.text, lineHeight: 1.5 }}>{children}</div>
        </div>
      )}
    </span>
  )
}
